import React from 'react'
import { Switch } from '@mui/material'
import { Add, Remove } from '@mui/icons-material'

const AviatorAutoBet = ({show}) => {
  return (
    <div className='aviatorAuto self-center z-50 bg-[#1b1c1d] rounded-lg px-4 py-2'>
        <div className='flex justify-between items-center p-2'>
            <div className='flex justify-center items-center space-x-2'>
                <p className='text-white'>AUTO PLAY OPTIONS</p>
            </div>
            <p onClick={() => show(false)} className='text-white cursor-pointer'>x</p>
       </div>
       <div className='flex flex-col bg-[#2c2d30] my-4 justify-center items-center rounded-lg px-2 py-1'>
           <p className='text-sm text-white'>Number of rounds</p>
           <div className='grid grid-cols-4 gap-2 my-1 w-full px-4'>
            <p className='rounded-full px-2 text-center text-gray-300 bg-[#1b1c1d]'>10</p>
            <p className='rounded-full px-2 text-center text-gray-300 bg-[#1b1c1d]'>20</p>
            <p className='rounded-full px-2 text-center text-gray-300 bg-[#1b1c1d]'>50</p>
            <p className='rounded-full px-2 text-center text-gray-300 bg-[#1b1c1d]'>100</p>
           </div>
       </div>

        <div className='flex flex-col space-y-4'>
            <div className='bg-[#2c2d30] rounded-lg flex justify-between items-center px-2 py-1'>
                <div className='flex  justfy-center items-center'>

                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
                    <p className='text-[0.8rem] text-white'>Stop if cash decreases by</p>
                </div>

                <div className='flex justify-between items-center bg-[#141516] rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                    <p  className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></p>
                    <p className='px-1 '>0.00</p>
                    <p className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></p>
                </div>
                <p className='text-gray-500 px-2'>uSD</p>
             </div>
             <div className='bg-[#2c2d30] rounded-lg flex justify-between items-center px-2 py-1'>
                <div className='flex  justfy-center items-center'>

                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
                    <p className='text-[0.8rem] text-white'>Stop if cash increases by</p>
                </div>

                <div className='flex justify-between items-center bg-[#141516] rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                    <p  className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></p>
                    <p className='px-1 '>0.00</p>
                    <p className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></p>
                </div>
                <p className='text-gray-500 px-2'>uSD</p>
             </div>
             <div className='bg-[#2c2d30] rounded-lg flex justify-between items-center p-1'>
                <div className='flex  justfy-center items-center'>

                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
                    <p className='text-[0.8rem] text-white'>Stop if single win exceeds</p>
                </div>

                <div className='flex justify-between items-center bg-[#141516] rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                    <p  className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></p>
                    <p className='px-1 '>0.00</p>
                    <p className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></p>
                </div>
                <p className='text-gray-500 px-2'>uSD</p>
             </div>
        </div>
        <div className='flex justify-center items-center space-x-4'>

        <button  className={`text-sm cursor-pointer flex justify-center items-center bg-[#fa8500] border border-white space-x-[4.2rem] rounded-full mt-8 font-semibold px-[0.8rem]`}>
            
            <p className="text-white">Reset</p>
        </button>      
        <button  className={`cursor-pointer flex justify-center items-center bg-[#28a909] border border-white space-x-[4.2rem] rounded-full mt-8 font-semibold px-[2rem]`}>
            
            <p className="text-white">Start</p>
        </button>
        </div>
    </div>
  )
}

export default AviatorAutoBet